module.exports = __webpack_public_path__ + "static/media/delivery-truck.42df1143.svg";